import { ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import clsx from 'clsx';

const badgeVariants = cva(
  'inline-flex items-center gap-1 whitespace-nowrap',
  {
    variants: {
      variant: {
        success: 'bg-[#d4f5e5] text-[#2DC47A]',
        warning: 'bg-[#fcf5e5] text-[#e8bc52]',
        error: 'bg-[#fce7e7] text-[#ed5e5e]',
        info: 'bg-[#e5f6fb] text-[#50c3e6]',
        neutral: 'bg-[#F4F6F9] text-[#7A8A9A]',
        brand: 'bg-[#e0ecf8] text-[#468AD4]',
        secondary: 'bg-[#ede7fb] text-[#865ce2]',
      },
      size: {
        sm: '',
        md: '',
      },
    },
    defaultVariants: {
      variant: 'neutral',
      size: 'sm',
    },
  }
);

interface BadgeProps extends VariantProps<typeof badgeVariants> {
  children: ReactNode;
  className?: string;
  /** Optional Playwright/RTL hook so callers can target a specific badge. */
  'data-testid'?: string;
}

export function Badge({
  variant,
  size,
  children,
  className,
  'data-testid': dataTestId,
}: BadgeProps) {
  return (
    <span
      className={clsx(badgeVariants({ variant, size }), className)}
      style={{
        padding: '3.3px 6.6px',
        fontSize: '10.56px',
        fontWeight: 500,
        borderRadius: '3.2px',
        lineHeight: 1,
      }}
      data-testid={dataTestId}
    >
      {children}
    </span>
  );
}
